/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrowsableOffice,
    BrowsableOfficeFromJSON,
    BrowsableOfficeFromJSONTyped,
    BrowsableOfficeToJSON,
} from './';

/**
 * ログインレスポンス
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    sessionKey: string;
    /**
     * consoleログイン時に指定するID
     * @type {string}
     * @memberof LoginResponse
     */
    consoleUserId: string;
    /**
     * consoleで表示されるユーザー名
     * @type {string}
     * @memberof LoginResponse
     */
    consoleUserName: string;
    /**
     * consoleの利用権限
     * @type {Array<string>}
     * @memberof LoginResponse
     */
    consoleUserPermissions: Array<string>;
    /**
     * 
     * @type {Array<BrowsableOffice>}
     * @memberof LoginResponse
     */
    browsableOffices: Array<BrowsableOffice>;
}

export function LoginResponseFromJSON(json: any): LoginResponse {
    return LoginResponseFromJSONTyped(json, false);
}

export function LoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sessionKey': json['session_key'],
        'consoleUserId': json['console_user_id'],
        'consoleUserName': json['console_user_name'],
        'consoleUserPermissions': json['console_user_permissions'],
        'browsableOffices': ((json['browsable_offices'] as Array<any>).map(BrowsableOfficeFromJSON)),
    };
}

export function LoginResponseToJSON(value?: LoginResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'session_key': value.sessionKey,
        'console_user_id': value.consoleUserId,
        'console_user_name': value.consoleUserName,
        'console_user_permissions': value.consoleUserPermissions,
        'browsable_offices': ((value.browsableOffices as Array<any>).map(BrowsableOfficeToJSON)),
    };
}


